module.exports = __webpack_public_path__ + "img/745.885f4286.jpg";